/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Accountsync {
    export class AccountsyncCheckDateRange implements angular.IDirective {
        require = '^form';
        restrict = 'A';
        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, formController: any) => {
            const name = element.find('ng-form').attr('name');

            if (!name) return;

            let checkTimeRangeFunction;
            switch (attrs.timeRangeType) {
                case 'week':
                    checkTimeRangeFunction = Meevo.Components.Controls.LimitDateRangeToRules.Week;
                    break;
                case 'month':
                    checkTimeRangeFunction = Meevo.Components.Controls.LimitDateRangeToRules.Months;
                    break;
                default:
                    checkTimeRangeFunction = Meevo.Components.Controls.LimitDateRangeToRules.Years
                    break;
            }

            scope.$watch(() => [formController[name]['from'].$viewValue, formController[name]['to'].$viewValue], () => {
                formController[name].$setValidity(
                    'timeRange',
                    checkTimeRangeFunction(formController[name]['from'].$viewValue, formController[name]['to'].$viewValue, attrs.timeRangeValue || 1)
                );
            }, true);
        };

        constructor() {}

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new AccountsyncCheckDateRange();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.plugins.accountsync')
        .directive('accountsyncCheckDateRange', AccountsyncCheckDateRange.factory());
}